const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcVolt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M413.624 197.408a10.677 10.677 0 0 0-9.28-5.408H264.611l23.426-178.995c.039-.372.059-.745.059-1.119 0-5.885-4.843-10.728-10.728-10.728a10.736 10.736 0 0 0-8.992 4.877L98.445 303.747a10.666 10.666 0 0 0-1.58 5.586c0 5.851 4.815 10.666 10.666 10.667h137.645l-18.565 179.264a10.63 10.63 0 0 0-.032.818c0 5.886 4.844 10.73 10.731 10.73 3.672 0 7.098-1.884 9.063-4.985l167.123-297.68a10.681 10.681 0 0 0 .128-10.739Z",
    style: {
      fill: "#727272",
      fillRule: "nonzero"
    },
    transform: "matrix(.04297 0 0 .04297 1 1)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVolt);
export default __webpack_public_path__ + "static/media/ic-volt.81cd5f3f11d181dba6867f83e5fea8c7.svg";
export { ForwardRef as ReactComponent };